import { render, staticRenderFns } from "./ShippingANWLocal.vue?vue&type=template&id=1536731a&scoped=true"
import script from "./ShippingANWLocal.vue?vue&type=script&lang=js"
export * from "./ShippingANWLocal.vue?vue&type=script&lang=js"
import style0 from "./ShippingANWLocal.vue?vue&type=style&index=0&id=1536731a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536731a",
  null
  
)

export default component.exports